import { FloatingTopBarProps } from './FloatingTopBar'

export const shouldShowStaticTopBar = ({ secondaryTopBarProps, progressBarProps }: FloatingTopBarProps): boolean => {
  if (!secondaryTopBarProps) {
    return false
  }

  return Boolean(
    !progressBarProps || secondaryTopBarProps?.buttonProps || secondaryTopBarProps?.previousLinkButtonProps,
  )
}
